import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  OnInit,
  Output,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ComboboxEvent, ComboboxSearchResult } from '@shared/abstraction';
import { User } from '@shared/models';
import { UserService } from '@shared/services/user.service';
import { cloneDeep } from 'lodash-es';
import { QueryOptions } from 'odata-query';
import { first, map } from 'rxjs';

@Component({
  standalone: false,
  selector: 'gstar-user-search',
  templateUrl: 'user-search.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserSearchComponent implements OnInit {
  private readonly userService = inject(UserService);

  @Output() userSelect: EventEmitter<User> = new EventEmitter<User>();

  highlightText: string = ' ';

  userList = signal<User[]>([]);

  destroyRef = inject(DestroyRef);

  query: Partial<QueryOptions<User>> = {
    filter: { isActive: true },
    orderBy: 'firstName',
  };

  userList$ = this.userService.get(this.query).pipe(
    takeUntilDestroyed(this.destroyRef),
    first(),
    map(response => response.items)
  );

  ngOnInit(): void {
    this.userList$.subscribe(userList =>
      this.userList.set(cloneDeep(userList))
    );
  }

  comboboxSelect(event: ComboboxEvent<User>): void {
    this.userSelect.emit(event.selected);
  }

  filterResult(comboboxFilterResult: ComboboxSearchResult<User>): void {
    this.highlightText = comboboxFilterResult.searchStr;
    if (comboboxFilterResult.result && comboboxFilterResult.result.length > 0) {
      this.userList.set(comboboxFilterResult.result);
    } else {
      this.userList.set([]);
    }
  }
}
